import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-sponsors',
    templateUrl: './sponsors.component.html',
    styleUrls: ['./sponsors.component.scss'],
    standalone: false
})
export class SponsorsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
